module.exports = "pegasus/assets/theme5/medium/2.jpg";